import React from 'react';
import {
  formatBadgePercentage,
  formatBadgePercentageText,
  formatBadgeStagePercentageText,
  roundedBadgePercentageValue,
  roundedBadgeStageThreshold,
} from './badgePercentageFormatting';

const defaultValueFormatter = formatBadgePercentage;

const BadgeLevelModal = ({
  title,
  description,
  currentValue,
  levels = [],
  valueLabel = 'Current Rate',
  formatValue = defaultValueFormatter,
  secondaryValue,
  secondaryValueLabel,
  formatSecondaryValue,
  extraInfo,
  close
}) => {
  const normalizedValue = roundedBadgePercentageValue(currentValue);
  const formattedValue = typeof formatValue === 'function' ? formatValue(normalizedValue) : defaultValueFormatter(normalizedValue);
  
  // Sort levels descending by threshold to ensure correct active level detection
  const sortedLevels = [...levels].sort((a, b) => roundedBadgeStageThreshold(b.threshold) - roundedBadgeStageThreshold(a.threshold));
  const fallbackLevel = sortedLevels.length > 0 ? sortedLevels[sortedLevels.length - 1] : null;
  const activeLevel = sortedLevels.find((level) => normalizedValue >= roundedBadgeStageThreshold(level.threshold)) || fallbackLevel;

  const hasSecondaryValue = typeof secondaryValue === 'number' && !Number.isNaN(secondaryValue);
  const formattedSecondary = hasSecondaryValue
    ? (typeof formatSecondaryValue === 'function' ? formatSecondaryValue(secondaryValue) : `${secondaryValue}`)
    : null;

  return (
    <div className="badge-level-modal">
      <h2>{title}</h2>
      {description && <p className="badge-level-description">{formatBadgePercentageText(description)}</p>}

      {extraInfo && extraInfo.length > 0 && (
        <div className="badge-level-extra-info">
          {extraInfo.map((info, idx) => (
            <div key={idx} className="badge-level-extra-row">
              <span className="label">{info.label}:</span>
              <span className="value">{formatBadgePercentageText(info.description)}</span>
            </div>
          ))}
        </div>
      )}

      <div className="badge-level-current">
        <div>
          <span className="label">{valueLabel}:</span>
          <span className="value">{formattedValue}</span>
        </div>
        {hasSecondaryValue && (
          <div>
            <span className="label">{secondaryValueLabel || 'Progress'}:</span>
            <span className="value">{formattedSecondary}</span>
          </div>
        )}
        {activeLevel && (
          <div>
            <span className="label">Current Level:</span>
            <span className="value">
              {activeLevel.icon && <span style={{ marginRight: '6px' }}>{activeLevel.icon}</span>}
              {activeLevel.label}
            </span>
          </div>
        )}
      </div>

      <div className="badge-level-list">
        {levels.map((level) => (
          <div key={level.label} className={`badge-level-row ${activeLevel === level ? 'active' : ''}`}>
            <div className="badge-level-icon">{level.icon || '•'}</div>
            <div className="badge-level-details">
              <div className="badge-level-name">{level.label}</div>
              <div className="badge-level-threshold">{formatBadgeStagePercentageText(level.thresholdLabel)}</div>
              {level.description && (
                <div className="badge-level-text">{formatBadgeStagePercentageText(level.description)}</div>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="badge-level-actions">
        <button className="btn-select" onClick={close}>Got it</button>
      </div>
    </div>
  );
};

export default BadgeLevelModal;
